export default "__VITE_ASSET__B8ONn7J0__"